
import { mapGetters } from 'vuex';
export default {
	components: {
		breadcrumbs	: () => import('../../components/pages/breadcrumbs.vue'),
		faq			: () => import('../../components/account/faq.vue')
	},
    computed: {
        ...mapGetters({
            getterTranslates: 'getterTranslates',
            getterStoreLang: 'getterStoreLang'
        })
    }
}
